<template>
  <qx-card-form title="充值油返利给承运司机比例">
    <qx-custom-form
      :noSubBtn="true"
      ref="baseForm"
      :formData="baseForm"
      labelWidth="160px"
    />
  </qx-card-form>
</template>

<script>
export default {
  data () {
    return {
      baseForm: {
        form: [
          {
            label: '智能模式',
            value: 'rtnAmtScaleZn',
            type: 'input',
          },
          {
            label: '报账模式',
            value: 'rtnAmtScaleBz',
            type: 'input',
          },
          {
            label: '承包模式',
            value: 'rtnAmtScaleCb',
            type: 'input',
          },
        ],
        rules: {
          rtnAmtScaleZn: [ // 智能模式
            { required: true, message: '请输入智能模式', trigger: 'blur' },
          ],
          rtnAmtScaleBz: [ // 报账模式
            { required: true, message: '请输入报账模式', trigger: 'blur' },
          ],
          rtnAmtScaleCb: [ // 承包模式
            { required: true, message: '请输入承包模式', trigger: 'blur' },
          ],
        },
      },
    };
  },
  methods: {
    async sub () {
      const result = {};
      const formData = await this.$refs.baseForm.sub();
      Object.keys(formData).forEach((key) => {
        result[`creditRatingRules_0.${key}`] = formData[key];
      });
      return result;
    },
    async cacheData () {
      const res = await this.$refs.baseForm.getVal();
      return res;
    },
    async init (data = {}) {
      this.$refs.baseForm.setVal(data);
    },
  },
};
</script>

<style scoped lang="scss">
</style>
